import React from 'react';

const MealSkeleton: React.FC = () => (
  <div className="bg-gray-50 border border-gray-200 rounded-lg hover:shadow-sm transition duration-300 p-2 mb-2">
    <div className="flex items-stretch">
      <div className="flex-grow min-w-0">
        <div className="h-5 bg-gray-200 rounded w-32 mb-2"></div>
        <div className="flex flex-wrap gap-1">
          {[...Array(4)].map((_, index) => (
            <div key={index} className="h-6 bg-gray-200 rounded w-16"></div>
          ))}
        </div>
      </div>
      <div className="flex shrink-0 ml-2">
        <div className="w-8 h-8 bg-gray-200 rounded-full mr-2"></div>
        <div className="w-8 h-8 bg-gray-200 rounded-full"></div>
      </div>
    </div>
  </div>
);

export default MealSkeleton;
